// extracted by mini-css-extract-plugin
module.exports = {"spred":"campaignAttachment__spred","lock":"campaignAttachment__lock","ul-drop-menu":"campaignAttachment__ul-drop-menu","iso-text":"campaignAttachment__iso-text"};